unit View.Grade_Linhas.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewGrade_LinhasEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbgrade_descricoes_id: TLabel;
    edgrade_descricoes_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcadastro: TLabel;
    edcadastro: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientGrade_LinhasGet: TXDataWebClient;
    XDataClientGrade_LinhasDelete: TXDataWebClient;
    Grade_LinhasDataset: TXDataWebDataSet;
    Grade_LinhasDatasetid: TIntegerField;
    Grade_LinhasDatasetaliado_id: TIntegerField;
    Grade_LinhasDatasetdata_base_id: TIntegerField;
    Grade_LinhasDatasetgrade_descricoes_id: TIntegerField;
    Grade_LinhasDatasetnome: TStringField;
    Grade_LinhasDatasetcadastro: TDateTimeField;
    Grade_LinhasDatasetcodigo_interno: TIntegerField;
    Grade_LinhasDatasetexcluido: TBooleanField;
    Grade_LinhasDatasetinclusao: TDateTimeField;
    Grade_LinhasDatasetalteracao: TDateTimeField;
    Grade_LinhasDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientGrade_LinhasGetLoad(Response: TXDataClientResponse);
    procedure XDataClientGrade_LinhasDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientGrade_LinhasDeleteError(Error: TXDataClientError);
    procedure Grade_LinhasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewGrade_LinhasEdit: TFViewGrade_LinhasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGrade_LinhasEdit }

procedure TFViewGrade_LinhasEdit.btSaveClick(Sender: TObject);
begin
  if Grade_LinhasDataset.State in dsEditModes then
  begin
        Grade_LinhasDataset.Post;
    Grade_LinhasDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewGrade_LinhasEdit.btDeleteClick(Sender: TObject);
begin
  if Grade_LinhasDataset.State in dsEditModes then
    Grade_LinhasDataset.Post;
  XDataClientGrade_LinhasDelete.Delete(Grade_LinhasDataset.EntitySetName,
    TJSObject(Grade_LinhasDataset.CurrentData));
end;


class function TFViewGrade_LinhasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewGrade_LinhasEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewGrade_LinhasEdit.InsertEntity;
begin
  Grade_LinhasDataset.Close;
  Grade_LinhasDataset.SetJsonData('{}');
  Grade_LinhasDataset.Open;
  Grade_LinhasDataset.Insert;
end;

class function TFViewGrade_LinhasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGrade_LinhasEdit(AForm).FInserting := AInserting;
    TFViewGrade_LinhasEdit(AForm).FId := AId;
    TFViewGrade_LinhasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewGrade_LinhasEdit(AForm).InsertEntity
    else
      TFViewGrade_LinhasEdit(AForm).LoadEntity;
    TFViewGrade_LinhasEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewGrade_LinhasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewGrade_LinhasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Grade_LinhasDataset.Connection.Model.DefaultSchema.FindEntityType(
      Grade_LinhasDataset.EntitySetName
    )
  );
  XDataClientGrade_LinhasGet.Get(Grade_LinhasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewGrade_LinhasEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewGrade_LinhasEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGrade_LinhasEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGrade_LinhasEdit.XDataClientGrade_LinhasGetLoad(Response: TXDataClientResponse);
begin
  Grade_LinhasDataset.Close;
  Grade_LinhasDataset.SetJsonData(Response.Result);
  Grade_LinhasDataset.Open;
  
  Grade_LinhasDataset.Edit;  
end;

procedure TFViewGrade_LinhasEdit.XDataClientGrade_LinhasDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewGrade_LinhasEdit.XDataClientGrade_LinhasDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewGrade_LinhasEdit.Grade_LinhasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewGrade_LinhasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewGrade_LinhasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.grade_linhas.form.message');
  lbMessage := TLabel.Create('view.grade_linhas.form.message.label');
  btCloseMessage := TButton.Create('view.grade_linhas.form.message.button');
  btCancel := TButton.Create('view.grade_linhas.form.btBack');
  btSave := TButton.Create('view.grade_linhas.form.btSave');
  btDelete := TButton.Create('view.grade_linhas.form.btDelete');
  lbid := TLabel.Create('view.grade_linhas.form.lbid');
  edid := TDBEdit.Create('view.grade_linhas.form.edid');
  lbaliado_id := TLabel.Create('view.grade_linhas.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.grade_linhas.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.grade_linhas.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.grade_linhas.form.eddata_base_id');
  lbgrade_descricoes_id := TLabel.Create('view.grade_linhas.form.lbgrade_descricoes_id');
  edgrade_descricoes_id := TDBEdit.Create('view.grade_linhas.form.edgrade_descricoes_id');
  lbnome := TLabel.Create('view.grade_linhas.form.lbnome');
  ednome := TDBEdit.Create('view.grade_linhas.form.ednome');
  lbcadastro := TLabel.Create('view.grade_linhas.form.lbcadastro');
  edcadastro := TDBEdit.Create('view.grade_linhas.form.edcadastro');
  lbcodigo_interno := TLabel.Create('view.grade_linhas.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.grade_linhas.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.grade_linhas.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.grade_linhas.form.edexcluido');
  lbinclusao := TLabel.Create('view.grade_linhas.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.grade_linhas.form.edinclusao');
  lbalteracao := TLabel.Create('view.grade_linhas.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.grade_linhas.form.edalteracao');
  lbexclusao := TLabel.Create('view.grade_linhas.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.grade_linhas.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Grade_LinhasDataset := TXDataWebDataSet.Create(Self);
  Grade_LinhasDatasetid := TIntegerField.Create(Self);
  Grade_LinhasDatasetaliado_id := TIntegerField.Create(Self);
  Grade_LinhasDatasetdata_base_id := TIntegerField.Create(Self);
  Grade_LinhasDatasetgrade_descricoes_id := TIntegerField.Create(Self);
  Grade_LinhasDatasetnome := TStringField.Create(Self);
  Grade_LinhasDatasetcadastro := TDateTimeField.Create(Self);
  Grade_LinhasDatasetcodigo_interno := TIntegerField.Create(Self);
  Grade_LinhasDatasetexcluido := TBooleanField.Create(Self);
  Grade_LinhasDatasetinclusao := TDateTimeField.Create(Self);
  Grade_LinhasDatasetalteracao := TDateTimeField.Create(Self);
  Grade_LinhasDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientGrade_LinhasGet := TXDataWebClient.Create(Self);
  XDataClientGrade_LinhasDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbgrade_descricoes_id.BeforeLoadDFMValues;
  edgrade_descricoes_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcadastro.BeforeLoadDFMValues;
  edcadastro.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Grade_LinhasDataset.BeforeLoadDFMValues;
  Grade_LinhasDatasetid.BeforeLoadDFMValues;
  Grade_LinhasDatasetaliado_id.BeforeLoadDFMValues;
  Grade_LinhasDatasetdata_base_id.BeforeLoadDFMValues;
  Grade_LinhasDatasetgrade_descricoes_id.BeforeLoadDFMValues;
  Grade_LinhasDatasetnome.BeforeLoadDFMValues;
  Grade_LinhasDatasetcadastro.BeforeLoadDFMValues;
  Grade_LinhasDatasetcodigo_interno.BeforeLoadDFMValues;
  Grade_LinhasDatasetexcluido.BeforeLoadDFMValues;
  Grade_LinhasDatasetinclusao.BeforeLoadDFMValues;
  Grade_LinhasDatasetalteracao.BeforeLoadDFMValues;
  Grade_LinhasDatasetexclusao.BeforeLoadDFMValues;
  XDataClientGrade_LinhasGet.BeforeLoadDFMValues;
  XDataClientGrade_LinhasDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewGrade_LinhasEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 562;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 502;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 502;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 502;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbgrade_descricoes_id.SetParentComponent(Self);
    lbgrade_descricoes_id.Name := 'lbgrade_descricoes_id';
    lbgrade_descricoes_id.Left := 24;
    lbgrade_descricoes_id.Top := 273;
    lbgrade_descricoes_id.Width := 14;
    lbgrade_descricoes_id.Height := 13;
    lbgrade_descricoes_id.Caption := 'grade_descricoes_id:';
    lbgrade_descricoes_id.Transparent := True;
    edgrade_descricoes_id.SetParentComponent(Self);
    edgrade_descricoes_id.Name := 'edgrade_descricoes_id';
    edgrade_descricoes_id.Left := 221;
    edgrade_descricoes_id.Top := 270;
    edgrade_descricoes_id.Width := 200;
    edgrade_descricoes_id.Height := 21;
    edgrade_descricoes_id.Enabled := True;
    edgrade_descricoes_id.TabOrder := 9;
    edgrade_descricoes_id.Text := 'edgrade_descricoes_id';
    edgrade_descricoes_id.DataField := 'grade_descricoes_id';
    edgrade_descricoes_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 300;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 297;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 10;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcadastro.SetParentComponent(Self);
    lbcadastro.Name := 'lbcadastro';
    lbcadastro.Left := 24;
    lbcadastro.Top := 327;
    lbcadastro.Width := 14;
    lbcadastro.Height := 13;
    lbcadastro.Caption := 'cadastro:';
    lbcadastro.Transparent := True;
    edcadastro.SetParentComponent(Self);
    edcadastro.Name := 'edcadastro';
    edcadastro.Left := 221;
    edcadastro.Top := 324;
    edcadastro.Width := 200;
    edcadastro.Height := 21;
    edcadastro.Enabled := True;
    edcadastro.TabOrder := 11;
    edcadastro.Text := 'edcadastro';
    edcadastro.DataField := 'cadastro';
    edcadastro.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 354;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 351;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 12;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 381;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 378;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 13;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 408;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 405;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 14;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 435;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 432;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 15;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 462;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 459;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 16;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Grade_LinhasDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Grade_LinhasDataset.SetParentComponent(Self);
    Grade_LinhasDataset.Name := 'Grade_LinhasDataset';
    Grade_LinhasDataset.AfterApplyUpdates := Grade_LinhasDatasetAfterApplyUpdates;
    Grade_LinhasDataset.EntitySetName := 'Grade_Linhas';
    Grade_LinhasDataset.Connection := DMConnection.ApiConnection;
    Grade_LinhasDataset.Left := 176;
    Grade_LinhasDataset.Top := 8;
    Grade_LinhasDatasetid.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetid.Name := 'Grade_LinhasDatasetid';
    Grade_LinhasDatasetid.FieldName := 'id';
    Grade_LinhasDatasetid.Required := True;
    Grade_LinhasDatasetaliado_id.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetaliado_id.Name := 'Grade_LinhasDatasetaliado_id';
    Grade_LinhasDatasetaliado_id.FieldName := 'aliado_id';
    Grade_LinhasDatasetaliado_id.Required := True;
    Grade_LinhasDatasetdata_base_id.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetdata_base_id.Name := 'Grade_LinhasDatasetdata_base_id';
    Grade_LinhasDatasetdata_base_id.FieldName := 'data_base_id';
    Grade_LinhasDatasetdata_base_id.Required := True;
    Grade_LinhasDatasetgrade_descricoes_id.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetgrade_descricoes_id.Name := 'Grade_LinhasDatasetgrade_descricoes_id';
    Grade_LinhasDatasetgrade_descricoes_id.FieldName := 'grade_descricoes_id';
    Grade_LinhasDatasetgrade_descricoes_id.Required := True;
    Grade_LinhasDatasetnome.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetnome.Name := 'Grade_LinhasDatasetnome';
    Grade_LinhasDatasetnome.FieldName := 'nome';
    Grade_LinhasDatasetnome.Required := True;
    Grade_LinhasDatasetnome.Size := 255;
    Grade_LinhasDatasetcadastro.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetcadastro.Name := 'Grade_LinhasDatasetcadastro';
    Grade_LinhasDatasetcadastro.FieldName := 'cadastro';
    Grade_LinhasDatasetcadastro.Required := False;
    Grade_LinhasDatasetcodigo_interno.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetcodigo_interno.Name := 'Grade_LinhasDatasetcodigo_interno';
    Grade_LinhasDatasetcodigo_interno.FieldName := 'codigo_interno';
    Grade_LinhasDatasetcodigo_interno.Required := True;
    Grade_LinhasDatasetexcluido.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetexcluido.Name := 'Grade_LinhasDatasetexcluido';
    Grade_LinhasDatasetexcluido.FieldName := 'excluido';
    Grade_LinhasDatasetexcluido.Required := False;
    Grade_LinhasDatasetinclusao.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetinclusao.Name := 'Grade_LinhasDatasetinclusao';
    Grade_LinhasDatasetinclusao.FieldName := 'inclusao';
    Grade_LinhasDatasetinclusao.Required := False;
    Grade_LinhasDatasetalteracao.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetalteracao.Name := 'Grade_LinhasDatasetalteracao';
    Grade_LinhasDatasetalteracao.FieldName := 'alteracao';
    Grade_LinhasDatasetalteracao.Required := False;
    Grade_LinhasDatasetexclusao.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetexclusao.Name := 'Grade_LinhasDatasetexclusao';
    Grade_LinhasDatasetexclusao.FieldName := 'exclusao';
    Grade_LinhasDatasetexclusao.Required := False;
    XDataClientGrade_LinhasGet.SetParentComponent(Self);
    XDataClientGrade_LinhasGet.Name := 'XDataClientGrade_LinhasGet';
    XDataClientGrade_LinhasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGrade_LinhasGet, Self, 'OnLoad', 'XDataClientGrade_LinhasGetLoad');
    XDataClientGrade_LinhasGet.Left := 64;
    XDataClientGrade_LinhasGet.Top := 8;
    XDataClientGrade_LinhasDelete.SetParentComponent(Self);
    XDataClientGrade_LinhasDelete.Name := 'XDataClientGrade_LinhasDelete';
    XDataClientGrade_LinhasDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGrade_LinhasDelete, Self, 'OnLoad', 'XDataClientGrade_LinhasDeleteLoad');
    SetEvent(XDataClientGrade_LinhasDelete, Self, 'OnError', 'XDataClientGrade_LinhasDeleteError');
    XDataClientGrade_LinhasDelete.Left := 64;
    XDataClientGrade_LinhasDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbgrade_descricoes_id.AfterLoadDFMValues;
    edgrade_descricoes_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcadastro.AfterLoadDFMValues;
    edcadastro.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Grade_LinhasDataset.AfterLoadDFMValues;
    Grade_LinhasDatasetid.AfterLoadDFMValues;
    Grade_LinhasDatasetaliado_id.AfterLoadDFMValues;
    Grade_LinhasDatasetdata_base_id.AfterLoadDFMValues;
    Grade_LinhasDatasetgrade_descricoes_id.AfterLoadDFMValues;
    Grade_LinhasDatasetnome.AfterLoadDFMValues;
    Grade_LinhasDatasetcadastro.AfterLoadDFMValues;
    Grade_LinhasDatasetcodigo_interno.AfterLoadDFMValues;
    Grade_LinhasDatasetexcluido.AfterLoadDFMValues;
    Grade_LinhasDatasetinclusao.AfterLoadDFMValues;
    Grade_LinhasDatasetalteracao.AfterLoadDFMValues;
    Grade_LinhasDatasetexclusao.AfterLoadDFMValues;
    XDataClientGrade_LinhasGet.AfterLoadDFMValues;
    XDataClientGrade_LinhasDelete.AfterLoadDFMValues;
  end;
end;

end.
